import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  LOCALE_ID,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Currency } from '@app/services/api/api.service';
import { LocaleInfo, LocaleService } from '@app/locale.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-locale-modal',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './locale-modal.component.html',
  styleUrl: './locale-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleModalComponent {
  public activeTab = 'locale';

  public locales: LocaleInfo[];
  public currencies: Currency[];
  public currentLocale: string;
  public currentCurrency: Observable<Currency>;

  private destroyed = new Subject<void>();

  constructor(
    private localeService: LocaleService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {
    this.locales = this.localeService.locales;
    this.currentLocale = this.locale;
    this.currentCurrency = this.localeService.currentCurrency;
    this.currencies = this.localeService.currencies;
    
    // Subscribe to initial tab
    this.localeService.initialModalTab$.subscribe(tab => {
      this.activeTab = tab;
    });
    // this.currencies = this.localeService.currencies$
    //   .pipe(
    //     takeUntil(this.destroyed)
    //   );

    // this.currencies.subscribe();
  }

  trackByCurrency(i: number, currency: Currency) {
    return currency.code;
  }

  setLocale(locale: LocaleInfo) {
    // Set override cookie to prevent future accept-language redirects
    document.cookie = `hh_locale_override=true; path=/; max-age=31536000`;

    const currentPath = window.location.pathname;
    const currentLangMatch = currentPath.match(/^\/(en|fr|es|de|it|pt)(\/|$)/);
    const currentLang = currentLangMatch ? currentLangMatch[1] : 'en';

    const newLang = locale.name;

    // Build the new path by replacing the language prefix if it exists
    let pathWithoutLang = currentPath;
    if (currentLangMatch) {
      pathWithoutLang = currentPath.replace(/^\/(en|fr|es|de|it|pt)/, '');
    }

    // Avoid double slashes, and avoid trailing slash on root paths
    const newPath = `/${
      newLang !== 'en' ? newLang : ''
    }${pathWithoutLang}`.replace(/\/+/g, '/');

    const newUrl = `${window.location.origin}${newPath}${window.location.search}`;

    if (currentLang !== newLang) {
      window.location.href = newUrl;
    }
  }

  setCurrency(currency: Currency) {
    this.localeService.setCurrency(currency);
  }

  close() {
    this.localeService.closeLocaleModal();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
